module.exports = __webpack_public_path__ + "img/contract.6ddc2a6.svg";